import type { RawComposeFormat } from "../store/schema/RawComposeFormat";
import type { ReadOnlyAccountConfiguration } from "owa-session-store";

export function getRawComposeFormat(settings?: ReadOnlyAccountConfiguration): RawComposeFormat | undefined {
    const userOption = settings?.UserOptions;
    return (userOption && {
        fontName: userOption.ComposeFontName,
        fontSize: userOption.ComposeFontSize,
        fontColor: userOption.ComposeFontColor,
        fontFlags: userOption.ComposeFontFlags,
    });
}
